import { useRef, useState } from "react";
import Input from "@Components/Input";
import styles from "../../../LeadFormModal/LeadFormModal.module.scss";
import { getLeaseDurationOptions } from "@Components/LeadForm/utils";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import DropdownIcon from "@Icons/DropdownIcon";
import useClickOutside from "hooks/useOutsideClick";
import { sleep } from "@Components/LeadFormModal/utils";
import useIsDesktop from "hooks/useIsDesktop";
import useIsHappyFlow from "hooks/useIsHappyFlow";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const StayDurationDropdown = ({
  error,
  setErrors,
  selectedDuration,
  setSelectedDuration,
  testIdPrefix,
}: any) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const ref = useRef(null);
  const isDesktop = useIsDesktop();
  const isHappyFlow = useIsHappyFlow();

  const handleSelectDuration = (duration: any) => {
    setSelectedDuration(duration);
    setErrors((errors: any) => ({ ...errors, duration: "" }));
    setShowOptions(false);
  };

  const { inventory } = useSelector(
    ({ leadFormModal }: AppState) => ({
      inventory: leadFormModal.inventory,
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();
  const country = inventory?.location?.country?.short_name;

  useClickOutside(ref, () => setShowOptions(false));

  const handleInputFocus = () => {
    setShowOptions(true);
    if (isHappyFlow && !isDesktop) {
      (async () => {
        await sleep(50);
        if (ref && ref.current) {
          // @ts-ignore
          ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      })();
    }
  };

  return (
    <div
      className={formatClassNames(styles.universityDropdownContainer, styles.stayDurationSection)}
      ref={ref}
    >
      <Input
        type="dropdown"
        label={t("leadform.components.personaldetailsform.staydurationlabel")}
        placeholder={t("leadform.components.personaldetailsform.staydurationplaceholder")}
        value={selectedDuration ? t(selectedDuration) : ""}
        onFocus={handleInputFocus}
        clearable
        handleClear={() => {
          setSelectedDuration("");
          setShowOptions(false);
        }}
        rightIcon={!selectedDuration && <DropdownIcon size={15} />}
        rightIconClassName={error ? styles.rightIconWithError : ""}
        showErrorMessage={Boolean(error)}
        error={error}
        dataTestId={`${testIdPrefix}leadform-input-stayDuration`}
        required
        id="durationAccomodation"
      />
      {showOptions && (
        <div
          className={formatClassNames(
            styles.universityDropdownOptContainer,
            styles.stayDurationDropdownOptContainer,
            isDesktop && isHappyFlow ? styles.desktopDropdownStyles : "",
          )}
        >
          {getLeaseDurationOptions(country).map((duration: any) => (
            <div
              key={duration}
              className={formatClassNames(
                styles.option,
                selectedDuration === duration ? styles.selected : "",
              )}
              onClick={() => handleSelectDuration(duration)}
              data-testid={`${testIdPrefix}leadform-stayDuration`}
              role="none"
            >
              <div>{t(duration)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(StayDurationDropdown, {
  componentName: "StayDurationDropdown-dropdown-LeadForm-Global",
  showForChina: true,
});
